import { useEffect, useState } from 'react';

import { useGlobalDialog } from "../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';
import { TableContainer } from '../../Styles/CustomViews/Pages/ListComponent/customListComponentStyles';
import { IconKey } from '@tabler/icons-react';

import { useCompanyHook } from '../../Hooks/Companies/companyHooks';
import { useLicenseHook } from '../../Hooks/License/licenseHooks';

import { IssueLicenseModalInterface } from '../../Models/License/License';
import { CompanyList } from '../../Models/Company/Company';

import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { CompanyListField, LicenseField } from '../../Utilities/Enums/ParametersEnum';
import { OrderByEnum } from '../../Utilities/Enums/SortEnums';

import { ErrorMessage } from '../../Constants/Messages';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import CustomListComponent from '../../CustomViews/Pages/ListComponent/CustomListComponent';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    width: 60vw;
`;

export default function IssueLicenseModal(props: IssueLicenseModalInterface) {
    let { openIssueLicenseModal, setopenIssueLicenseModal, licensePublicId, getCompanyData } = props;
    const { enqueueSnackbar } = useSnackbar();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();

    //Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
        sortBy: QueryBuilderHelper.DefaultSortValue(CompanyListField.NAME),
        orderBy: QueryBuilderHelper.DefaultOrderValue(OrderByEnum.DESC),
    });
    const [licenseQueryStr, setlicenseQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.COMPANIES, queryStr];
    const license_q_queryKey = [CachingEnum.LICENSES, licenseQueryStr]
    const { data, fetchStatus } = useCompanyHook(q_queryKey, queryStr);
    const { allocateLicenseById } = useLicenseHook(license_q_queryKey, licenseQueryStr, false);

    const tableColumns = [
        {
            accessor: CompanyListField.NAME,
            title: 'Company Name',
            sortable: true,
        },
        {
            accessor: CompanyListField.CONTACT_PERSON,
            sortable: true,
        },
        {
            accessor: CompanyListField.CONTACT_PHONE,
            title: 'Contact Number',
            sortable: true,
        },
        {
            accessor: CompanyListField.FULL_ADDRESS,
            title: 'Location',
            sortable: true,
        },
        {
            accessor: 'action',
            title: "Action",
            render: (record: CompanyList) => <>
                <CustomButton
                    btnType={ButtonType.PRIMARY}
                    title='Issue Now'
                    startIcon={<IconKey />}
                    onClick={(e: any) => {
                        issueLicenseNow(record?.[CompanyListField.PUBLIC_ID] ?? "");
                    }} />
            </>
        },
    ];

    //Event Handlers
    const issueLicenseNow = async (companyPublicId: string | number) => {
        let _success: boolean = false;

        if(licensePublicId && companyPublicId) {
            let allocateResponse = await allocateLicenseById(licensePublicId, JSON.stringify({[LicenseField.COMPANY_PUBLIC_ID]: companyPublicId}));

            _success = allocateResponse?.isSuccess ?? false;
        } else {
            enqueueSnackbar(ErrorMessage.PROBLEM_ALLOCATING_LICENSE, { variant: 'error' });
        }

        if(_success) {
            if(getCompanyData) {
                getCompanyData();
            }

            onCloseDialog();
        }
    }

    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenIssueLicenseModal) {
            setopenIssueLicenseModal(false);
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openIssueLicenseModal) {
            setDialogContent({
                title: "Issue License to Company",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                children: renderDialogContent(),
            });
        }
    }, [openIssueLicenseModal, fetchStatus, data]);

    //Rendering Functions
    const renderDialogContent = () => {
        return <ModalContentContainer>
            <TableContainer>
                <CustomListComponent
                    fetching={fetchStatus == "fetching"}
                    columns={tableColumns}
                    idAccessor={(record: CompanyList) => `company${record?.[CompanyListField.PUBLIC_ID]}`}
                    records={data?.data?.list ?? []}
                    totalRecords={data?.data?.metaData?.totalCount ?? 0}
                    page={queryStr.pageNumber}
                    recordsPerPage={queryStr.pageSize}
                    defaultColumnSort={{ columnAccessor: queryStr?.sortBy ?? 'id', direction: queryStr?.orderBy ?? 'asc' }}
                    onSortStatusChange={((sort: any) => { setQueryStr((prev: any) => ({ ...prev, sortBy: sort?.columnAccessor ?? "id", orderBy: sort?.direction ?? "asc", pageNumber: 1 })) })}
                    setPage={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageNumber: p }))}
                    onRecordsPerPageChange={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageSize: p, pageNumber: 1 }))} />
            </TableContainer>
        </ModalContentContainer>
    }

    return <></>
}